import { JobOpeningIcon } from "../assets/svg/JobOpening";

export const referralsData = [
    { id: "1", 
      candidateName: "Marvin McKinney", 
      jobtitle: "UX desginer", 
      referredBy: "Amebros jenkins", 
      experience: "5 Years", 
      currentEmployer: "Mail pin pvt ltd" 
    },
    { id: "2", 
      candidateName: "Marvin McKinney", 
      jobtitle: "UX desginer", 
      referredBy: "Amebros jenkins", 
      experience: "5 Years", 
      currentEmployer: "Mail pin pvt ltd" 
    },
    { id: "3", 
      candidateName: "Marvin McKinney", 
      jobtitle: "UX desginer", 
      referredBy: "Amebros jenkins", 
      experience: "5 Years", 
      currentEmployer: "Mail pin pvt ltd" 
    },
    { id: "4", 
      candidateName: "Marvin McKinney", 
      jobtitle: "UX desginer", 
      referredBy: "Amebros jenkins", 
      experience: "5 Years", 
      currentEmployer: "Mail pin pvt ltd" 
    },
    { id: "5", 
      candidateName: "Marvin McKinney", 
      jobtitle: "UX desginer", 
      referredBy: "Amebros jenkins", 
      experience: "5 Years", 
      currentEmployer: "Mail pin pvt ltd" 
    },

  ];

  export const referralsTabs = [
         { label: 'Referrals Details', Icon: JobOpeningIcon },
  ]